// extracted by mini-css-extract-plugin
export default {"form":"Create_form__oTjCF","smallContainer":"Create_smallContainer__faHob","actions":"Create_actions__2x9Ep"};